"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99154],{

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 499154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DetailPage": function() { return /* reexport */ DetailPage/* DetailPage */.H; },
  "DetailPageSGC": function() { return /* reexport */ DetailPageSGC_DetailPage/* DetailPageSGC */.r; },
  "MAX_WIDTH": function() { return /* reexport */ DetailPageSGC_DetailPage/* MAX_WIDTH */.d; },
  "NewDetailPage": function() { return /* reexport */ NewDetailPage; }
});

// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/DetailPage.tsx
var DetailPage = __webpack_require__(606174);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NoProductsFound/NoProductsFound.es.js + 1 modules
var NoProductsFound_es = __webpack_require__(493460);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
// EXTERNAL MODULE: ./components/LazyComponent.tsx
var LazyComponent = __webpack_require__(110413);
// EXTERNAL MODULE: ./components/ProductDetail/styles.ts
var styles = __webpack_require__(243290);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/product-detail/shared/FlashSalePromotionBlock.tsx + 3 modules
var FlashSalePromotionBlock = __webpack_require__(981282);
// EXTERNAL MODULE: ./modules/product-detail/shared/NewLayoutComponents/ProductInfo.tsx
var ProductInfo = __webpack_require__(534631);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductReview/ReviewSection.tsx + 10 modules
var ReviewSection = __webpack_require__(715292);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-62ae8f912b/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(504545);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/NewProductDescription.tsx
var NewProductDescription = __webpack_require__(915935);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tekface-smart-activation-virtual-e73eef34fa/0/cache/@tekface-smart-activation-npm-1.0.10-2939c41d04-992c9a64f7.zip/node_modules/@tekface/smart-activation/dist/components/InlineBannerPlaceholder.es.js
var InlineBannerPlaceholder_es = __webpack_require__(560327);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js
var Overlay_es = __webpack_require__(92300);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/YoutubeIframe/YoutubeIframe.es.js
var YoutubeIframe_es = __webpack_require__(55930);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Glide/Glide.es.js
var Glide_es = __webpack_require__(816519);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SmallImage/SmallImages.es.js
var SmallImages_es = __webpack_require__(732324);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductVideo/ProductVideo.es.js
var ProductVideo_es = __webpack_require__(7297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Gallery/Gallery.es.js
var Gallery_es = __webpack_require__(888393);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ./constants/smartBanner.ts
var smartBanner = __webpack_require__(124177);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductImageZoom.tsx
var ProductImageZoom = __webpack_require__(893202);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/new-components/NewProductImages.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  position: relative;\n  margin-bottom: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  background-color: #f5f5f5;\n  height: 388px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  aspect-ratio: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  .horizontal-slider,\n  .glide__track {\n    // 90px l\xe0 chiều dầi 1 slide (tối đa 5 silide) - 8px l\xe0 chiều d\xe0i khoảng c\xe1ch giữa c\xe1c slide (c\xf3 4 đoạn gap)\n    width: ",
        "px;\n  }\n  .glide__slide {\n    width: 90px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









const NewProductImages = ()=>{
    const { product , frame , inlineBanners  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { 0: showGallery , 1: setShowGallery  } = (0,react.useState)(false);
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react.useState)(0);
    const vidRef = (0,react.useRef)(null);
    const images = (product === null || product === void 0 ? void 0 : product.images) || [];
    const videos = (product === null || product === void 0 ? void 0 : product.videos) || [];
    const displayItems = [
        ...videos,
        ...images
    ];
    const renderDisplayItems = ()=>{
        return displayItems.map((img, index)=>{
            if (index < videos.length) {
                if (img.source === index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailVideo, {
                            url: img.url,
                            source: img.source,
                            isActive: index === activeIndex,
                            videoProps: {
                                ref: vidRef,
                                width: "100%",
                                height: "100%",
                                preload: "none",
                                playsInline: true,
                                autoPlay: true,
                                muted: true,
                                onClick: ()=>setActiveIndex(index),
                                onPlayingCapture: ()=>{
                                    var ref;
                                    return (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.pause();
                                }
                            }
                        }, index)
                    }, index);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledYoutubeThumbnail, {
                        width: "100%",
                        height: "100%",
                        isActive: index === activeIndex,
                        youtubeLink: img.url,
                        onClick: ()=>{
                            setActiveIndex(index);
                        }
                    }, index)
                }, index);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItemFrame, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallImages_es/* SmallImage */.K, {
                    width: "100%",
                    height: "100%",
                    borderRadius: 4,
                    borderColor: "#dddddd",
                    image: img,
                    alt: img.alt,
                    isActive: index === activeIndex,
                    borderWidth: index === activeIndex ? 1.5 : 1,
                    onClick: ()=>{
                        setActiveIndex(index);
                    }
                }, index)
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", _objectSpreadProps(_objectSpread({}, (0,helper_es/* getTrackingData */.O5)({
        isTrackContent: true,
        regionName: "imgProductDetail",
        contentName: "viewImage",
        target: "productImage",
        payload: JSON.stringify({
            sku: product === null || product === void 0 ? void 0 : product.sellerSku,
            screenName: "productDetail",
            index: activeIndex
        })
    })), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBigImages, {
                className: "productDetailPreview" // class for pushdy banner
                ,
                children: [
                    frame && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameWrapper, {
                        frame: frame
                    }),
                    images || videos ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBannerPlaceholder_es/* BannerInlinePlaceholder */.Q, {
                                banners: inlineBanners,
                                className: smartBanner/* INLINE_BANNER_CLASSNAME.INLINE_PDP_PREVIEW_DESK */.h.INLINE_PDP_PREVIEW_DESK
                            }),
                            activeIndex < videos.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                                source: videos[activeIndex].source,
                                videoProps: {
                                    preload: "none",
                                    width: 385,
                                    height: 385,
                                    playsInline: true,
                                    muted: true,
                                    autoPlay: true,
                                    controls: true,
                                    src: videos[activeIndex].url,
                                    onClick: ()=>setShowGallery(true)
                                },
                                youtubeFrameProps: {
                                    width: 325,
                                    height: 325,
                                    autoplay: 1
                                },
                                url: videos[activeIndex].url
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImageZoom/* default */.Z, {
                                onClick: ()=>setShowGallery(true),
                                image: images[activeIndex - videos.length],
                                height: 385
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGlide, _objectSpreadProps(_objectSpread({
                bound: true,
                gap: 8,
                perView: 5
            }, displayItems.length <= 4 && {
                showControl: false,
                dragThreshold: false,
                swipeThreshold: false
            }), {
                displayNewLayout: true,
                children: renderDisplayItems()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay_es/* Overlay */.a, {
                show: showGallery,
                onEscPressed: ()=>setShowGallery(false),
                children: images ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery_es/* Gallery */.r, {
                    images: images,
                    videos: videos === null || videos === void 0 ? void 0 : videos.map((video)=>{
                        return _objectSpreadProps(_objectSpread({}, video), {
                            src: video.url
                        });
                    }),
                    bgColor: "white",
                    onClose: ()=>setShowGallery(false),
                    activeImageIndex: activeIndex
                }) : null
            })
        ]
    }));
};
const FrameWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { frame  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  background-image: url(".concat(frame, ");\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n  ");
});
const StyledBigImages = emotion_styled_browser_esm["default"].div(_templateObject());
const StyledYoutubeThumbnail = (0,emotion_styled_browser_esm["default"])(YoutubeIframe_es/* YoutubeThumbnail */.F)((param)=>{
    let { isActive , theme  } = param;
    return "\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n");
});
const ThumbnailVideo = (0,emotion_styled_browser_esm["default"])(ProductVideo_es/* ProductVideo */.N)((param)=>{
    let { isActive , theme  } = param;
    return "\n  cursor: pointer;\n  border: 1.5px solid\n    ".concat(isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "#dddddd", ";\n  transition: 0.1s ease opacity;\n  &:hover {\n    opacity: 0.6;\n  }\n");
});
const StyledItemFrame = emotion_styled_browser_esm["default"].div(_templateObject1());
const StyledGlide = (0,emotion_styled_browser_esm["default"])(Glide_es/* Glide */.A)(_templateObject2(), 90 * 5 + 8 * 4);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ./components/WishlistButton.tsx
var WishlistButton = __webpack_require__(288257);
// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPage/ShareButtons.tsx + 1 modules
var ShareButtons = __webpack_require__(439764);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/new-components/ShareAndWishlist.tsx
function ShareAndWishlist_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ShareAndWishlist_templateObject() {
    const data = ShareAndWishlist_taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    ShareAndWishlist_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const ShareAndWishlist = ()=>{
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
        align: "bottom",
        justify: "start",
        marginBottom: "s12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtons/* ShareButtons */.n, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                level: 1,
                children: (0,i18n.t)("Y\xeau th\xedch")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                sku: product.sku,
                size: "24"
            })
        ]
    });
};
const Divider = emotion_styled_browser_esm["default"].div(ShareAndWishlist_templateObject());

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/NewDetailPage.tsx















const FAQSection = dynamic_default()(()=>__webpack_require__.e(/* import() */ 65458).then(__webpack_require__.bind(__webpack_require__, 565458)).then((mod)=>mod.FAQSection), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(565458)
            ]
    }
});
const NewDetailPage = ()=>{
    var ref;
    const { product , breadcrumbs , relatedProducts  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { epicOmni1550  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    if (!product) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* NotFoundProductLayout */.DH, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoProductsFound_es/* NoProductsFound */.H, {
                show: true,
                text: (0,i18n.t)("Kh\xf4ng t\xecm thấy sản phẩm")
            })
        });
    }
    const arrowStyle = {
        backgroundColor: "white",
        borderRadius: 999,
        boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 15px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
        marginBottom: "s16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                breadcrumbs: breadcrumbs || []
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                padding: "s12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    align: "start",
                    gap: "s24",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xu, {
                            width: "57.5%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProductImages, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareAndWishlist, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xu, {
                            width: "calc(100% - 57.5%)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSalePromotionBlock/* FlashSalePromotionBlock */._, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                    marginBottom: "s12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfo/* ProductInfo */.w, {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    gap: "s16",
                    marginTop: "s16",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xu, {
                            width: "68.5%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProductDescription/* ProductDescription */.v, {
                                    tabTitle: [
                                        (0,i18n.t)("Th\xf4ng số kỹ thuật"),
                                        (0,i18n.t)("Chi tiết sản phẩm")
                                    ],
                                    buttonType: "ghost"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xu, {
                            width: "calc(100% - 68.5% - 16px)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                    children: "Related news"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                                    marginTop: "s16",
                                    children: "Related videos"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                children: epicOmni1550 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewSection.ReviewSection, {})
            }),
            !!((ref = product.seoInfo) === null || ref === void 0 ? void 0 : ref.faq) && product.seoInfo.faq.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_es/* Card */.Z, {
                    marginTop: "s16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection, {
                        faq: product.seoInfo.faq,
                        style: {
                            padding: "0px 16px"
                        }
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComponent/* LazyComponent */.c, {
                children: relatedProducts.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_es/* Card */.Z, {
                    marginTop: "s16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader_es/* BlockHeader */.t, {
                            title: (0,i18n.t)("Sản phẩm li\xean quan")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_es/* ProductCarousel */.G, {
                            products: relatedProducts,
                            productsPerRow: 5,
                            regionName: "relatedProducts",
                            virtual: (0,helpers/* isServerless */.ep)(),
                            customStyleLeftArrow: arrowStyle,
                            customStyleRightArrow: arrowStyle
                        })
                    ]
                }) : null
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPage/index.ts



// EXTERNAL MODULE: ./modules/product-detail/desktop/DetailPageSGC/DetailPage.tsx + 11 modules
var DetailPageSGC_DetailPage = __webpack_require__(483531);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/index.ts


;// CONCATENATED MODULE: ./modules/product-detail/desktop/index.ts




/***/ }),

/***/ 534631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ProductInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(825078);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(723357);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534924);
/* harmony import */ var helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(347822);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  ",
        "\n  margin: 0;\n  text-align: left;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  color: #000000a6;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









const shortenString = function(name) {
    let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var ref;
    const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
    if (!trimmedName) return "";
    if (trimmedName.length <= maxLength) return trimmedName;
    return "".concat((ref = trimmedName.slice(0, maxLength)) === null || ref === void 0 ? void 0 : ref.trimEnd(), "...");
};
const ProductBrand = (param)=>{
    let { brandCode , brandName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: {
            pathname: "/brands/[brandId]",
            query: {
                brandId: brandCode
            }
        },
        as: {
            pathname: "/".concat(brandCode, "-brand.").concat(brandCode)
        },
        shallow: true,
        passHref: true,
        legacyBehavior: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandNameTextLink, {
            children: shortenString(brandName)
        })
    });
};
const ProductInfo = ()=>{
    var ref, ref1, ref2, ref3;
    const { epicOmni1550 , isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlags */ .g)();
    const theme = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
    const { productRatingData , product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useProductDetailState */ .W)();
    const { totalReviews , averageRating  } = productRatingData;
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
        direction: "column",
        gap: "s4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                    level: 1,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Thương hiệu:")
                        }),
                        flags.epic_omni_1552 && (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) > 0 ? product.brands.map((brand, index)=>{
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                                        brandCode: brand.code,
                                        brandName: brand.name
                                    }, "".concat(brand.code).concat(brand.name).concat(index)),
                                    index + 1 !== (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) && ",\xa0"
                                ]
                            }, index);
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                            brandCode: product === null || product === void 0 ? void 0 : (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.code,
                            brandName: product === null || product === void 0 ? void 0 : (ref2 = product.brand) === null || ref2 === void 0 ? void 0 : ref2.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, {
                align: "top",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Col */ .JX, {
                        flex: isMobile ? "75%" : "100%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductName, {
                            isMobile: isMobile,
                            level: 1,
                            color: theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.black,
                            weight: "bold",
                            children: product.displayName || product.name
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .Col */ .JX, {
                        flex: "25%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                            align: "center",
                            justify: "end",
                            gap: "s4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                    level: 1,
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Y\xeau th\xedch")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_12__/* .WishlistButton */ .s, {
                                    sku: product.sku,
                                    size: "24"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        level: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                            children: [
                                "SKU: ",
                                product.sellerSku || product.sku
                            ]
                        })
                    }),
                    epicOmni1550 && !!totalReviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, {
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__/* .RatingFilled */ .A, {
                                size: 20,
                                color: "support"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                weight: "bold",
                                margin: [
                                    "s0",
                                    "s4"
                                ],
                                children: averageRating
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                level: 1,
                                color: "primary",
                                onClick: ()=>(0,helpers_page_actions__WEBPACK_IMPORTED_MODULE_14__/* .scrollSmoothToIdWithOffset */ .A)("review-section", isMobile ? 60 : 90),
                                style: {
                                    cursor: "pointer"
                                },
                                children: "(".concat(totalReviews, " ").concat((0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("đ\xe1nh gi\xe1"), ")")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const ProductName = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Heading */ .X6)(_templateObject(), (param)=>{
    let { isMobile  } = param;
    return isMobile ? "\n    font-size: 20px;\n    line-height: 28px;\n    " : "\n    font-size: 24px;\n    line-height: 32px;\n    ";
});
const BrandNameTextLink = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].a((param)=>{
    let { theme  } = param;
    var ref;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary, ";\n  font-weight: normal;\n  margin-left: 4px;\n  font-size: 13px;\n  line-height: 20px;\n  text-decoration: none;\n");
});
const Text = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].span(_templateObject1());
const Divider = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject2());


/***/ })

}]);